"use strict";Object.defineProperty(exports,"__esModule",{value:!0});const s=require("styled-components").createGlobalStyle`
@font-face {
    font-family: "Basis Grotesque Pro";
    src: url("https://media-assets.swiggy.com/dls-web-assets/dls/fonts/BasisGrotesquePro-BlackIt.eot");
    src: url("https://media-assets.swiggy.com/dls-web-assets/dls/fonts/BasisGrotesquePro-BlackIt.eot?#iefix")
            format("embedded-opentype"),
        url("https://media-assets.swiggy.com/dls-web-assets/dls/fonts/BasisGrotesquePro-BlackIt.woff2")
            format("woff2"),
        url("https://media-assets.swiggy.com/dls-web-assets/dls/fonts/BasisGrotesquePro-BlackIt.woff")
            format("woff"),
        url("https://media-assets.swiggy.com/dls-web-assets/dls/fonts/BasisGrotesquePro-BlackIt.ttf")
            format("truetype");
    font-weight: 800;
    font-style: italic;
    font-display: swap;
}

@font-face {
    font-family: "Basis Grotesque Pro";
    src: url("https://media-assets.swiggy.com/dls-web-assets/dls/fonts/BasisGrotesquePro-Black.eot");
    src: url("https://media-assets.swiggy.com/dls-web-assets/dls/fonts/BasisGrotesquePro-Black.eot?#iefix")
            format("embedded-opentype"),
        url("https://media-assets.swiggy.com/dls-web-assets/dls/fonts/BasisGrotesquePro-Black.woff2")
            format("woff2"),
        url("https://media-assets.swiggy.com/dls-web-assets/dls/fonts/BasisGrotesquePro-Black.woff")
            format("woff"),
        url("https://media-assets.swiggy.com/dls-web-assets/dls/fonts/BasisGrotesquePro-Black.ttf")
            format("truetype");
    font-weight: 800;
    font-style: normal;
    font-display: swap;
}

@font-face {
    font-family: "Basis Grotesque Pro";
    src: url("https://media-assets.swiggy.com/dls-web-assets/dls/fonts/BasisGrotesquePro-BoldIt.eot");
    src: url("https://media-assets.swiggy.com/dls-web-assets/dls/fonts/BasisGrotesquePro-BoldIt.eot?#iefix")
            format("embedded-opentype"),
        url("https://media-assets.swiggy.com/dls-web-assets/dls/fonts/BasisGrotesquePro-BoldIt.woff2")
            format("woff2"),
        url("https://media-assets.swiggy.com/dls-web-assets/dls/fonts/BasisGrotesquePro-BoldIt.woff")
            format("woff"),
        url("https://media-assets.swiggy.com/dls-web-assets/dls/fonts/BasisGrotesquePro-BoldIt.ttf")
            format("truetype");
    font-weight: 700;
    font-style: italic;
    font-display: swap;
}

@font-face {
    font-family: "Basis Grotesque Pro";
    src: url("https://media-assets.swiggy.com/dls-web-assets/dls/fonts/BasisGrotesquePro-Bold.eot");
    src: url("https://media-assets.swiggy.com/dls-web-assets/dls/fonts/BasisGrotesquePro-Bold.eot?#iefix")
            format("embedded-opentype"),
        url("https://media-assets.swiggy.com/dls-web-assets/dls/fonts/BasisGrotesquePro-Bold.woff2")
            format("woff2"),
        url("https://media-assets.swiggy.com/dls-web-assets/dls/fonts/BasisGrotesquePro-Bold.woff")
            format("woff"),
        url("https://media-assets.swiggy.com/dls-web-assets/dls/fonts/BasisGrotesquePro-Bold.ttf")
            format("truetype");
    font-weight: 700;
    font-style: normal;
    font-display: swap;
}

@font-face {
    font-family: "Basis Grotesque Pro";
    src: url("https://media-assets.swiggy.com/dls-web-assets/dls/fonts/BasisGrotesquePro-MediumIt.eot");
    src: url("https://media-assets.swiggy.com/dls-web-assets/dls/fonts/BasisGrotesquePro-MediumIt.eot?#iefix")
            format("embedded-opentype"),
        url("https://media-assets.swiggy.com/dls-web-assets/dls/fonts/BasisGrotesquePro-MediumIt.woff2")
            format("woff2"),
        url("https://media-assets.swiggy.com/dls-web-assets/dls/fonts/BasisGrotesquePro-MediumIt.woff")
            format("woff"),
        url("https://media-assets.swiggy.com/dls-web-assets/dls/fonts/BasisGrotesquePro-MediumIt.ttf")
            format("truetype");
    font-weight: 400;
    font-style: italic;
    font-display: swap;
}

@font-face {
    font-family: "Basis Grotesque Pro";
    src: url("https://media-assets.swiggy.com/dls-web-assets/dls/fonts/BasisGrotesquePro-Medium.eot");
    src: url("https://media-assets.swiggy.com/dls-web-assets/dls/fonts/BasisGrotesquePro-Medium.eot?#iefix")
            format("embedded-opentype"),
        url("https://media-assets.swiggy.com/dls-web-assets/dls/fonts/BasisGrotesquePro-Medium.woff2")
            format("woff2"),
        url("https://media-assets.swiggy.com/dls-web-assets/dls/fonts/BasisGrotesquePro-Medium.woff")
            format("woff"),
        url("https://media-assets.swiggy.com/dls-web-assets/dls/fonts/BasisGrotesquePro-Medium.ttf")
            format("truetype");
    font-weight: 400;
    font-style: normal;
    font-display: swap;
}

@font-face {
    font-family: "Basis Grotesque Pro";
    src: url("https://media-assets.swiggy.com/dls-web-assets/dls/fonts/BasisGrotesquePro-Regular.eot");
    src: url("https://media-assets.swiggy.com/dls-web-assets/dls/fonts/BasisGrotesquePro-Regular.eot?#iefix")
            format("embedded-opentype"),
        url("https://media-assets.swiggy.com/dls-web-assets/dls/fonts/BasisGrotesquePro-Regular.woff2")
            format("woff2"),
        url("https://media-assets.swiggy.com/dls-web-assets/dls/fonts/BasisGrotesquePro-Regular.woff")
            format("woff"),
        url("https://media-assets.swiggy.com/dls-web-assets/dls/fonts/BasisGrotesquePro-Regular.ttf")
            format("truetype");
    font-weight: 200;
    font-style: normal;
    font-display: swap;
}

@font-face {
    font-family: "Basis Grotesque Pro";
    src: url("https://media-assets.swiggy.com/dls-web-assets/dls/fonts/BasisGrotesquePro-It.eot");
    src: url("https://media-assets.swiggy.com/dls-web-assets/dls/fonts/BasisGrotesquePro-It.eot?#iefix")
            format("embedded-opentype"),
        url("https://media-assets.swiggy.com/dls-web-assets/dls/fonts/BasisGrotesquePro-It.woff2")
            format("woff2"),
        url("https://media-assets.swiggy.com/dls-web-assets/dls/fonts/BasisGrotesquePro-It.woff")
            format("woff"),
        url("https://media-assets.swiggy.com/dls-web-assets/dls/fonts/BasisGrotesquePro-It.ttf")
            format("truetype");
    font-weight: 200;
    font-style: italic;
    font-display: swap;
}

@font-face {
    font-family: "ProximaNovaCond-Black";
    src: url("https://media-assets.swiggy.com/dls-web-assets/dls/fonts/ProximaNovaCond-Black.eot");
    src: url("https://media-assets.swiggy.com/dls-web-assets/dls/fonts/ProximaNovaCond-Black.eot?#iefix")
            format("embedded-opentype"),
        url("https://media-assets.swiggy.com/dls-web-assets/dls/fonts/ProximaNovaCond-Black.woff2")
            format("woff2"),
        url("https://media-assets.swiggy.com/dls-web-assets/dls/fonts/ProximaNovaCond-Black.woff")
            format("woff"),
        url("https://media-assets.swiggy.com/dls-web-assets/dls/fonts/ProximaNovaCond-Black.ttf")
            format("truetype");
    font-weight: 800;
    font-style: normal;
    font-display: swap;
}

@font-face {
    font-family: "ProximaNovaCond-Extrabld";
    src: url("https://media-assets.swiggy.com/dls-web-assets/dls/fonts/ProximaNovaCond-Extrabld.eot");
    src: url("https://media-assets.swiggy.com/dls-web-assets/dls/fonts/ProximaNovaCond-Extrabld.eot?#iefix")
            format("embedded-opentype"),
        url("https://media-assets.swiggy.com/dls-web-assets/dls/fonts/ProximaNovaCond-Extrabld.woff2")
            format("woff2"),
        url("https://media-assets.swiggy.com/dls-web-assets/dls/fonts/ProximaNovaCond-Extrabld.woff")
            format("woff"),
        url("https://media-assets.swiggy.com/dls-web-assets/dls/fonts/ProximaNovaCond-Extrabld.ttf")
            format("truetype");
    font-weight: 700;
    font-style: normal;
    font-display: swap;
}

@font-face {
    font-family: "ProximaNovaCond-Bold";
    src: url("https://media-assets.swiggy.com/dls-web-assets/dls/fonts/ProximaNovaCond-Bold.eot");
    src: url("https://media-assets.swiggy.com/dls-web-assets/dls/fonts/ProximaNovaCond-Bold.eot?#iefix")
            format("embedded-opentype"),
        url("https://media-assets.swiggy.com/dls-web-assets/dls/fonts/ProximaNovaCond-Bold.woff2")
            format("woff2"),
        url("https://media-assets.swiggy.com/dls-web-assets/dls/fonts/ProximaNovaCond-Bold.woff")
            format("woff"),
        url("https://media-assets.swiggy.com/dls-web-assets/dls/fonts/ProximaNovaCond-Bold.ttf")
            format("truetype");
    font-weight: 600;
    font-style: normal;
    font-display: swap;
}

@font-face {
    font-family: "ProximaNovaCond-Medium";
    src: url("https://media-assets.swiggy.com/dls-web-assets/dls/fonts/ProximaNovaCond-Medium.eot");
    src: url("https://media-assets.swiggy.com/dls-web-assets/dls/fonts/ProximaNovaCond-Medium.eot?#iefix")
            format("embedded-opentype"),
        url("https://media-assets.swiggy.com/dls-web-assets/dls/fonts/ProximaNovaCond-Medium.woff2")
            format("woff2"),
        url("https://media-assets.swiggy.com/dls-web-assets/dls/fonts/ProximaNovaCond-Medium.woff")
            format("woff"),
        url("https://media-assets.swiggy.com/dls-web-assets/dls/fonts/ProximaNovaCond-Medium.ttf")
            format("truetype");
    font-weight: 400;
    font-style: normal;
    font-display: swap;
}
`;exports.FontStyle=s;
//# sourceMappingURL=Fonts.js.map
